<script lang="ts" setup>
import { computed } from 'vue'
import { getCards } from '@/helpers/cards'
import type { TCards } from '@/types/basic'

interface CardRowSimpleProps {
  cards?: TCards
  board?: string
  tstPrefix?: string
}

const props = withDefaults(defineProps<CardRowSimpleProps>(), {
  cards: () => [],
  tstPrefix: 'crdrow_simple',
})

const computedCards = computed(() => (props.cards.length ? props.cards : getCards(props.board)))
</script>

<template>
  <div
    class="card-row_simple"
    :data-tst="`${tstPrefix}_${computedCards.join('')}`"
  >
    <div
      v-for="(card, idx) in computedCards"
      :key="card + idx + 'cardrow'"
      style="
        --height: var(--crds-card-height);
        --value-size-increase: var(--crds-card-value-size-increase);
      "
      :class="`poker-card poker-card_mini card_${card[1]}`"
    >
      <div class="card-value">
        {{ card[0] }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card-row_simple {
  display: flex;
  --crds-card-height: 1.8rem;
  --crds-card-value-size-increase: 0.9;
}
</style>
